import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import './style/ds/tokens.css';
import './index.css';
import App from './App'
import Cookies from 'js-cookie';

// DEV-only: /?ds=app renders the logged-in shell with a mock session (design work).
// Gated to development so it can NEVER bypass auth in production.
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('ds') === 'app') {
    Cookies.set('userData', JSON.stringify({
        token: 'dev', privateName: 'יובל', lastName: 'לגה6',
        business: [{ ID: '3', businessToken: 'dev', groupName: 'מנהל', groupPriority: '1', names: [{ name: 'לגה6' }] }],
        user: { id: '3', role: 'owner', name: 'יובל לגה6' },
    }));
    Cookies.set('authToken', 'dev');
    Cookies.set('busiToken', 'dev');
    Cookies.set('loginKey', 'true');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
    // updateViaCache:'none' → the browser always revalidates the SW script over the network,
    // so a new ServiceWorker.js is picked up promptly instead of from HTTP cache.
    navigator.serviceWorker.register('/serviceWorker.js', { updateViaCache: 'none' }).then(registration => {
        registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {                         // New update available
                        // Prompt the user to refresh
                    }
                }
            };
        };
    }).catch(error => {
        console.log('Service Worker registration failed:', error);
    });
    // Note: on a new deploy the SW itself force-reloads open windows during `activate` (only
    // when it replaced a previous cache version), so no controllerchange reload is needed here.
}

root.render(
    <StrictMode>
        <App/>
    </StrictMode>
);


